import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import Flex from 'components/Flex'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import {
  BoldTextDate,
  ExtraSpaceNew,
  GreyText,
  NameAdd1,
  SecondaryHeading,
  StyledP,
  SubFLex,
  TextLight1,
  VerticalDivider,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import React from 'react'
import { COLORS } from 'theme'

const InfoSection = ({
  name,
  company,
  work,
  skills,
  duration,
  jobFunction,
  role,
  industry,
  flag,
}) => {
  return (
    <SubFLex column gap="25px">
      <SubFLex gap="12px">
        <div>
          <Avatar
            background="none"
            src={''}
            size={48}
            icon={<ApartmentIcon />}
            boxShadow={true}
            padding="5px"
          />
        </div>
        <SubFLex column style={{ width: '90%' }}>
          <SecondaryHeading>
            {name} {name && company && '-'} {company}
          </SecondaryHeading>
          <GreyText color={COLORS.GREY_T_60}>{duration}</GreyText>
          {skills?.length ? (
            <>
              <SecondaryHeading fontWeight="700" fontSize="15px">
                Skills
              </SecondaryHeading>
              <SubFLex centerVertically gap="5px" marginBottom="15px" wrap>
                {skills?.map((item, index) => (
                  <CustomTag
                    message={item?.name}
                    bordered={true}
                    background={'#F2F3F5'}
                    border={'#F2F3F5'}
                    key={index + item?.name}
                  />
                ))}
              </SubFLex>
            </>
          ) : null}
          {flag && (
            <Flex centerVertically>
              {jobFunction && (
                <>
                  <NameAdd1 column flexStart>
                    <TextLight1 color={COLORS.GREY_T_20}>Function</TextLight1>
                    <BoldTextDate color={COLORS.GREY_T_20}>
                      {jobFunction}
                    </BoldTextDate>
                  </NameAdd1>
                  {role && <VerticalDivider type="vertical" />}
                </>
              )}
              {role && (
                <>
                  <NameAdd1 column flexStart>
                    <TextLight1 color={COLORS.GREY_T_20}>Role</TextLight1>
                    <BoldTextDate color={COLORS.GREY_T_20}>{role}</BoldTextDate>
                  </NameAdd1>
                  {industry && <VerticalDivider type="vertical" />}
                </>
              )}
              {industry && (
                <NameAdd1 column flexStart>
                  <TextLight1 color={COLORS.GREY_T_20}>Industry</TextLight1>
                  <BoldTextDate color={COLORS.GREY_T_20}>
                    {industry}
                  </BoldTextDate>
                </NameAdd1>
              )}
            </Flex>
          )}
          {work && (
            <>
              <ExtraSpaceNew />
              <StyledP
                dangerouslySetInnerHTML={{
                  __html: work,
                }}
              />
            </>
          )}
        </SubFLex>
      </SubFLex>
    </SubFLex>
  )
}

export default InfoSection
